import { useEffect, useRef, useContext } from "react";
import { StateContext } from "../../../../Context/Context";

export const useIntersectionObserver = () => {
  const observer = useRef(null);
  const { state, setState } = useContext(StateContext);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setState({ ...state, section: entry.target.id });
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
    // eslint-disable-next-line
  }, []);

  const observe = (element) => {
    if (element && observer.current) {
      observer.current.observe(element);
    }
  };

  return observe;
};
